import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('adminGovernanceProcessControllers')
        .factory('adminGovernanceProcessService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {
	    var baseUrl = environment.apiUrl + '/Pilot/api/GovernanceProcess';

		var service = {
		    createProcess: createProcess,
            updateProcess: updateProcess
		};
		return service;

		////////////

        // Create Process
		function createProcess(govProcess) {
		    var reqUrl = baseUrl;

		    return $http.post(reqUrl, { GovernanceProcess: govProcess })
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Update Process
		function updateProcess(govProcess) {
		    var reqUrl = baseUrl;

		    return $http.put(reqUrl + '/' + govProcess.GovernanceProcessID, {
		        GovernanceProcess: govProcess
		    })
            .then(function (response) {
                return response.data;
            });
		}
	}
})();
